import { Button } from "components/button";

export default function StoreFormContainer({
  children,
  submitLabel,
  onSubmit = () => {},
  submitParams,
  submitHref,
  onSecondary = () => {},
  secondaryLabel,
  secondaryHref,
  secondaryParams,
  submitDisabled = false,
  secondaryDisabled = false,
  stickyFooter = false,
}) {
  return (
    <form
      className="h-[calc(100vh-81px)] flex flex-col justify-between overflow-auto"
      onSubmit={(e) => {
        e.preventDefault();
      }}
    >
      <div className="flex flex-col px-6 h-full">{children}</div>
      <div
        className={`flex justify-between p-6 ${!secondaryLabel && "ml-auto"} ${stickyFooter && "fixed bottom-0 left-0 right-0 z-40 border-t border-gray-300 bg-white"}`}
      >
        {secondaryLabel && (
          <Button
            variant="secondary"
            href={secondaryHref}
            type="button"
            disabled={secondaryDisabled}
            onClick={onSecondary}
            queryParams={secondaryParams}
          >
            {secondaryLabel}
          </Button>
        )}
        {submitLabel && (
          <Button
            disabled={submitDisabled}
            href={submitHref}
            type="submit"
            onClick={onSubmit}
            queryParams={submitParams}
          >
            {submitLabel}
          </Button>
        )}
      </div>
    </form>
  );
}
